const NEEDED_RIGHTS = ['POLICIES_PREMIUM_SHOW'];

export { NEEDED_RIGHTS };
